import { gql } from "apollo-boost"

export const GET_IMPLEMENTER_PROJECTS = gql`
  query getImplementerProjects($implementerId: ID!) {
    ImplementerProjects(implementerId: $implementerId) {
      id
      name
    }
  }
`